import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Table from "../../../../components/Table";
import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import Input from "../../../../components/Input";
import { ModalDelete } from "../../../../components/ModalDelete";

import api from "../../../../services/api";
import { renderError } from "../../../../helpers/errors";

export const CostCentersTab = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [costCenters, setCostCenters] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [costCenterToEdit, setCostCenterToEdit] = useState(null);
    const [costCenterToDelete, setCostCenterToDelete] = useState(null);

    const [name, setName] = useState('');

    useEffect(() => {
        getCostCenters();
    }, []);

    const getCostCenters = () => {
        setLoading(true);

        api.get(`/finance-cost-center`).then(res => {
            setCostCenters(res.data.resources);
        }).catch(renderError).then(() => setLoading(false));
    };

    const openModal = costCenter => {
        setCostCenterToEdit(costCenter);
        setName(costCenter?.name ?? '');
        setShowModal(true);
    };

    const save = () => {
        setSaving(true);

        const request = costCenterToEdit
            ? api.put(`/finance-cost-center/${costCenterToEdit.id}`, { name })
            : api.post(`/finance-cost-center`, { name });

        request.then(() => {
            toast.success('Centro de custo salvo');
            setShowModal(false);
            getCostCenters();
        }).catch(renderError).then(() => setSaving(false));
    };

    const deleteCostCenter = () => {
        setDeleting(true);

        api.delete(`/finance-cost-center/${costCenterToDelete.id}`).then(() => {
            setCostCenterToDelete(null);
            getCostCenters();
        }).catch(renderError).then(() => setDeleting(false));
    };

    const rows = costCenters.map(costCenter => ({
        data: [costCenter.name],
        buttons: [
            <Button type={`delete`} svg={`delete`} action={() => setCostCenterToDelete(costCenter)} />,
        ],
        action: () => openModal(costCenter),
    }));

    return (
        <>
            <ModalDelete
                show={costCenterToDelete !== null}
                text={<p>Tem certeza que deseja apagar o centro de custo <strong>{costCenterToDelete?.name}</strong>?</p>}
                action={deleteCostCenter}
                loading={deleting}
                close={() => setCostCenterToDelete(null)}
            />
            <Modal
                title={costCenterToEdit ? 'Editar centro de custo' : 'Novo centro de custo'}
                show={showModal}
                close={() => setShowModal(false)}
                footer={<Button type={`primary`} size={`small`} text={`Salvar`} action={save} loading={saving} />}
            >
                <div className="section">
                    <div className="row">
                        <div className="col-12">
                            <Input label={`Nome`} value={name} change={setName} />
                        </div>
                    </div>
                </div>
            </Modal>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                <Button type={`primary`} size={`small`} svg={`plus-white`} text={`Novo centro de custo`} action={() => openModal(null)} />
            </div>
            <Table header={['Nome', '']} rows={rows} loading={loading} />
        </>
    );
};

export default CostCentersTab;
